<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect class="active-status" width="24" height="24" fill="white" fill-opacity="0.01"/>
    <path class="active-status" d="M10.0001 19V14.5C10.0001 13.9696 10.2108 13.4609 10.5858 13.0858C10.9609 12.7108 11.4696 12.5 12.0001 12.5C12.5305 12.5 13.0392 12.7108 13.4143 13.0858C13.7893 13.4609 14.0001 13.9696 14.0001 14.5V19H18.0001C18.2653 19 18.5196 18.8947 18.7072 18.7072C18.8947 18.5196 19.0001 18.2653 19.0001 18V10.169L12.7071 3.87305C12.5195 3.68558 12.2652 3.58026 12.0001 3.58026C11.7349 3.58026 11.4806 3.68558 11.2931 3.87305L5.00006 10.169V18C5.00006 18.2653 5.10542 18.5196 5.29295 18.7072C5.48049 18.8947 5.73484 19 6.00006 19H10.0001ZM21.0001 12.17V18C21.0001 18.7957 20.684 19.5588 20.1214 20.1214C19.5588 20.684 18.7957 21 18.0001 21H6.00006C5.20441 21 4.44135 20.684 3.87874 20.1214C3.31613 19.5588 3.00006 18.7957 3.00006 18V12.17L2.96006 12.21C2.57006 12.6 1.93006 12.6 1.54006 12.21C1.15006 11.82 1.15006 11.18 1.54006 10.79L9.87906 2.45905C10.4416 1.89663 11.2046 1.58069 12.0001 1.58069C12.7956 1.58069 13.5585 1.89663 14.1211 2.45905L22.4601 10.79C22.8501 11.18 22.8501 11.82 22.4601 12.21C22.0701 12.6 21.4301 12.6 21.0401 12.21L21.0001 12.17Z" fill="#42526E"/>
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
